<template>
  <div class="comp">
    <div class="compContent">
      <div class="title">
        <div class="titleL">编辑疫苗驱虫信息</div>
        <div class="titleR">
          <el-button type="warning" plain size="small" @click="back">返回</el-button>
        </div>
      </div>
      <div class="content">
        <div class="no">疫苗驱虫单号：{{ detail.id }}</div>
        <div class="msg">
          <div class="item">
            <div class="label">顾客姓名：</div>
            <div class="value">{{ detail.memberName }}</div>
          </div>
          <div class="item">
            <div class="label">手机号码：</div>
            <div class="value">{{ detail.memberMobile }}</div>
          </div>
          <div class="item">
            <div class="label">项目类型：</div>
            <div class="value">
              {{ detail.serviceTypeId == 1 ? "疫苗" : "驱虫" }}
            </div>
          </div>
          <div class="item">
            <div class="label">套餐名称：</div>
            <div class="value">{{ detail.servicePackageName }}</div>
          </div>
          <div class="item">
            <div class="label">支付方式：</div>
            <div class="value">
              全额支付
              <!-- <el-radio-group v-model="detail.payType" disabled>
								<el-radio :label="1">全额支付</el-radio>
								<el-radio :label="2">计划支付</el-radio>
								<el-radio :label="3">套餐卡支付</el-radio>
								<el-input v-show="detail.payType==3" :rows="4" :value="detail.cardName" disabled style="width:220px"></el-input>
							</el-radio-group> -->
            </div>
          </div>
          <div class="item">
            <div class="label">宠物昵称：</div>
            <div class="value">
              {{ detail.petName }} ({{ detail.typeName }})
            </div>
          </div>
          <div class="item">
            <div class="label">宠物性别：</div>
            <div class="value">{{ detail.sex }}</div>
          </div>
          <div class="item">
            <div class="label">宠物年龄：</div>
            <div class="value">
              {{
                $public.FTime(new Date(detail.birthDay).getTime(), "YYYY-MM-DD")
              }}
              <span style="color: #1853a4; margin-left: 10px">
                ({{ $public.FAge(new Date(detail.birthDay).getTime())[0] }}岁
                {{ $public.FAge(new Date(detail.birthDay).getTime())[1] }}月)
              </span>
            </div>
          </div>
          <div class="item">
            <div class="label">创建人：</div>
            <div class="value">
              {{ detail.createUserName }}
            </div>
          </div>
          <div class="item">
            <div class="label">创建时间：</div>
            <div class="value">
              {{ $public.FTime(detail.createTime) }}
            </div>
          </div>
          <div class="item">
            <div class="label"></div>
            <div class="value">
              <div v-if="detail.beforeReplace">
                <el-button type="success" @click="dialog_batchAdd_state = true">批量添加</el-button>
                <el-button type="primary" @click="dialog_batchEdit_state = true">批量更换</el-button>
                <el-button type="danger" @click="dialog_batchDel_state = true">批量移除</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="relation">
          <div class="relationTitLine">
            <div>计划列表</div>
            <div>
              <el-button v-if="detail.serviceStatus !== 2" type="text" icon="el-icon-plus" size="small"
                @click="changePlan('')">添加一个新计划</el-button>
            </div>
          </div>
          <el-table :stripe="true" :data="detail.plans" style="width: 100%" @expand-change="expandChange" :ref="'table'">
            <el-table-column width="35">
              <template slot-scope="scope">
                <el-checkbox v-model="selectedArr[scope.$index]" :disabled="detail.payType === 1 ||
                  detail.serviceStatus == 2 ||
                  (detail.payType === 2 && !scope.row.currPlan)
                  " @change="changeTotal(arguments[0], 'selectPlan')"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column type="expand" width="30">
              <template slot-scope="scope">
                <div class="goodsLine">
                  <div class="goodsLineTit">
                    <div>用药列表</div>
                    <div>
                      <div v-if="scope.row.planLock == false">
                        <el-button v-if="scope.row.planStatus != 2 &&
                          detail.serviceStatus != 2
                          " type="text" icon="el-icon-plus" size="small"
                          @click="addGoods(scope.$index)">添加药品</el-button>
                      </div>
                    </div>
                  </div>
                  <el-table :data="scope.row.planGoods" :ref="'table' + scope.$index">
                    <el-table-column width="35">
                      <template slot-scope="props">
                        <el-checkbox v-model="selectedArrArr[scope.$index][props.$index]" :disabled="!!props.row.orderNum ||
                          props.row.canDelete === false ||
                          detail.serviceStatus == 2 ||
                          (detail.payType === 2 && !props.row.currPlan) ||
                          props.row.replaceType === 2
                          " @change="changeTotal(arguments[0], 'selectGoods')"></el-checkbox>
                      </template>
                    </el-table-column>
                    <el-table-column label="名称" prop="goodsName" min-width="140">
                      <template slot-scope="props">
                        {{ props.row.dosageCeiling === 1 ? "[ 整 ] " : "" }}
                        {{ props.row.goodsName }}
                        <span v-if="props.row.replaceType === 2" style="color: #fdd000">(换)</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="规格" prop="skuValue" width="80">
                    </el-table-column>
                    <el-table-column label="数量" prop="num" width="80">
                      <template slot-scope="props">
                        <el-input :disabled="!!props.row.orderNum ||
                          detail.serviceStatus == 2 ||
                          props.row.replaceType == 2
                          " v-model="props.row.num" @blur="
    $public.isNull(props.row.num) &&
    changeTotal(
      arguments[0],
      'changeNum',
      props.row,
      'blur'
    )
    " @input="
    changeTotal(arguments[0], 'changeNum', props.row)
    " size="small" style="width: 70px">
                        </el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="单位" prop="unit" width="50">
                    </el-table-column>
                    <el-table-column label="出库量" width="180">
                      <template slot-scope="props">
                        <div class="cishu">
                          <el-input :disabled="!$public.isNull(props.row.orderNum) ||
                            props.row.replaceType == 2
                            " v-model="props.row.goodsDosage" @blur="
    $public.isNull(props.row.goodsDosage) &&
    changeTotal(
      arguments[0],
      'changeGoodsDosage',
      props.row,
      'blur'
    )
    " @input="
    changeTotal(
      arguments[0],
      'changeGoodsDosage',
      props.row
    )
    " size="small" style="width: 130px">
                            <template slot="append"  style="padding: 0;">{{
                              props.row.outUnit
                            }}</template>
                          </el-input>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="单价" prop="originalPrice" width="70">
                    </el-table-column>
                    <el-table-column label="换算单位" width="100">
                      <template slot-scope="props">
                        {{ props.row.unit_changesrc }}={{
                          props.row.unit_changedesc
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column label="库存" width="100">
                      <template slot-scope="props">
                        <span v-if="props.row.skuStocks &&
                            props.row.skuStocks.length > 0
                            ">
                          {{
                            $public.getMatchingItem(
                              props.row.skuStocks[props.row.skuValueIndex]
                                .lstStock,
                              "shopId",
                              curShopId
                            ).stock
                          }}
                       </span>
                        <span v-else>--</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="支付状态" width="70">
                      <template slot-scope="props">
                        <span v-if="props.row.isPay" style="color: #18a44c">已支付</span>
                        <span v-else>
                          <span v-if="props.row.orderNum" style="color: #fdd000">待支付</span>
                          <span v-if="!props.row.orderNum" style="color: red">未支付</span>
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="小计" width="70">
                      <template slot-scope="props">
                        {{ $public.getSubtotal(props.row) }}
                      </template>
                    </el-table-column>
                    <el-table-column label="是否补差价" width="80">
                      <template slot-scope="props" v-if="props.row.replaceType === 2">
                        <el-switch :disabled="props.row.diffPrice <= 0 ||
                          !$public.isNull(props.row.orderNum)
                          " :value="!props.row.notCount" @change="changeNotCount(arguments[0], props.row)"></el-switch>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" prop="goods_name" v-if="detail.serviceStatus != 2" width="120">
                      <!-- 失效 -->
                      <template slot-scope="props" v-if="scope.row.planStatus != 2">
                        <div v-if="props.row.isOut === false">
                          <div v-if="scope.row.planLock == false">
                            <el-button v-if="props.row.isPay == true &&
                              props.row.replaceType == 0 &&
                              props.row.goodsType == 1
                              " type="text" @click=" changeGoods( props.row,scope.$index,props.$index)" size="mini">更换</el-button>
                            <el-button v-if="!props.row.orderNum &&
                              props.row.replaceType == 2
                              " type="text" @click="cancelGoods(props.row)" size="mini">取消更换</el-button>
                            <el-button v-if="!props.row.orderNum &&
                              props.row.replaceType == 0 &&
                              props.row.canDelete == true
                              " type="text" @click="deleteGoods(props.row,scope.$index,props.$index)" size="mini">删除</el-button>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div style="
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    padding: 10px 10px;
                  ">
                  <div>
                    <span>共计：</span><span style="margin-right: 70px">
                      {{ plansMoney[scope.$index].count }}件
                    </span>
                    <span>套餐计划价：</span><span style="margin-right: 70px">
                      ￥{{ scope.row.planMoney }}
                    </span>
                    <span style="color: red">差价：</span><span style="color: red; margin-right: 50px">
                      ￥{{
                        plansMoney[scope.$index].paid === 0
                        ? 0
                        : plansMoney[scope.$index].unpaid
                      }}
                    </span>
                    <span style="color: #18a44c">已支付：</span><span style="color: #18a44c; margin-right: 40px">
                      ￥{{ plansMoney[scope.$index].paid }}
                    </span>
                    <span>小计：</span><span style="margin-right: 20px">
                      ￥{{ plansMoney[scope.$index].total }}
                    </span>
                  </div>
                  <div>
                    <span style="color: red">总计：</span><span style="color: red; margin-right: 20px">￥{{
                      plansMoney[scope.$index].unpaid }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="计划名称" min-width="120" prop="planName">
            </el-table-column>
            <el-table-column label="计划日期" min-width="90">
              <template slot-scope="scope">
                <div>{{ $public.FTime(scope.row.planDate, "YYYY-MM-DD") }}</div>
              </template>
            </el-table-column>·
            <el-table-column label="实施日期" prop="memberName" min-width="90">
              <template slot-scope="scope">
                <div>
                  {{ $public.FTime(scope.row.handlerTime, "YYYY-MM-DD") }}
                  <el-button v-if="scope.row.planStatus == 2&&$buttonAuthority('yewu-yiliaoxin-editDate')&&detail.oneSelf" type="text" size="mini"
                    @click="changeCarry(scope.row)">编辑</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="距离下一次计划" align="center" prop="intervalDays" min-width="105">
              <template slot-scope="scope">
                {{ scope.row.intervalDays }}天
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="planMoney" min-width="60">
            </el-table-column>
            <el-table-column label="状态" prop="planStatus" min-width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.planStatus == 2" style="color: #18a44c">已完成</span>
                <span v-else style="color: red">未完成</span>
              </template>
            </el-table-column>
            <el-table-column label="经办人" min-width="100">
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.salesMans" :key="index">
                  {{ item.userName }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="支付状态" min-width="70">
              <template slot-scope="scope">
                <span v-if="scope.row.payState === 1" style="color: #18a44c">已支付</span>
                <span v-if="scope.row.payState === 2" style="color: #fdd000">待支付</span>
                <span v-if="scope.row.payState === 3" style="color: red">未支付</span>
              </template>
            </el-table-column>
            <el-table-column label="所属门店" min-width="70">
              <template slot-scope="props">
                <span v-if="props.row.currShopId">{{
                  $public.getShopNameById(props.row.currShopId)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" min-width="80">
            </el-table-column>
            <el-table-column label="完成备注" prop="handlerRemark" min-width="80">
            </el-table-column>
            <el-table-column label="操作" width="140" v-if="detail.serviceStatus != 2">
              <template slot-scope="scope" v-if="scope.row.planLock == false">
                <el-button v-if="scope.row.isPay == 1 &&
                  scope.row.planStatus == 1 &&
                  checkedCompleteBtn(scope.row.planDate)
                  " type="text" size="mini" @click="completePlan(scope.row)">已完成</el-button>
                <el-button v-if="scope.row.planStatus == 1" type="text" size="mini"
                  @click="changePlan(scope.row)">编辑</el-button>
                <el-button v-if="scope.row.isPay == 0 && scope.row.canDelete" type="text" size="mini"
                  @click="deletePlan(scope.row, scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center; margin: 70px 0 150px">
            <div v-if="detail.serviceStatus !== 2">
              <el-button type="danger" style="width: 140px; margin-left: 50px" @click="changeInvalid">标记为已失效</el-button>
            </div>
            <div v-if="detail.serviceStatus == 2">
              <el-button type="danger" disabled style="width: 100px; margin-left: 50px">已失效</el-button>
            </div>
          </div>
        </div>
        <div v-if="dialogAddGoods_state">
          <dialogAddShop :addShopState="dialogAddGoods_state" :shopId="curShopId" :tree="[
            {
              id: '602f1e88c904d9db7ccf3bec',
              children: [
                { id: '602f1e88c904d9db7ccf3bed' },
                { id: '602f1e89c904d9db7ccf3bf6' },
                { id: '602f1e89c904d9db7ccf3bf8' },
                { id: '602f1e89c904d9db7ccf3bfc' },
                { id: '602f1e89c904d9db7ccf3bff' },
              ],
            },
          ]" @submit="submit_dialogAddGoods" @closeOn="dialogAddGoods_state = false"></dialogAddShop>
        </div>
        <div v-if="dialogChangeGoods_state">
          <dialogChangeGoods :replaceRate="detail.replaceRate" :oldGoods="propsRow" :posi="[scopeId, propsId]"
            @submit="submitChangeGoods"></dialogChangeGoods>
        </div>
        <div v-if="dialogShouyin_state">
          <dialogShouyin :type="1" :bingliMsg="detail" :delPaid="totalMoney.delPaid" :selectedArr="shouyinData"
            @submit="submit_shouyin" @close="dialogShouyin_state = false"></dialogShouyin>
        </div>
        <div v-if="dialogPay_state">
          <dialogQRCode :QRCode="codeUrl" :orderNum="orderNumber" @submit="submit_dialog_pay"></dialogQRCode>
        </div>
        <div v-if="dialogComplete_state">
          <dialogComplete :id="cur_complete_id" :type="'ymqc'" @submit="submit_dialog_complete"></dialogComplete>
        </div>
        <div v-if="dialogChangePlan_state">
          <dialogChangePlan :row="curRow" :detail="detail" @submit="submit_dialogChangePlan"></dialogChangePlan>
        </div>
        <div v-if="dialogChangeCarry_state">
          <dialogChangeCarry :row="curRow" :detail="detail" @submit="submit_dialogChangeCarry"></dialogChangeCarry>
        </div>
        <div v-if="dialog_batchAdd_state">
          <dialogBatchAdd :ymqcDetail="detail" @submit="submit_dialog_batchAdd"></dialogBatchAdd>
        </div>
        <div v-if="dialog_batchEdit_state">
          <dialogBatchEdit :ymqcDetail="detail" @submit="submit_dialog_batchEdit"></dialogBatchEdit>
        </div>
        <div v-if="dialog_batchDel_state">
          <dialogBatchDel :ymqcDetail="detail" @submit="submit_dialog_batchDel"></dialogBatchDel>
        </div>
      </div>
    </div>
    <div class="settlement">
      <div class="settlementL">
        <span>共计：</span><span style="font-size: 16px; margin-right: 30px">{{ totalMoney.count }}件</span>
        <span>套餐计划价：</span><span style="font-size: 16px; margin-right: 30px">￥{{ detail.packageMoney }}</span>
        <span v-if="orderNumber !== ''">
          有未支付订单，
          <span style="color: #32a05b; cursor: pointer" @click="openDialogPay">去支付</span>
          <span style="color: red; cursor: pointer; margin-left: 10px" @click="closeOrder">取消</span>
        </span>
      </div>
      <div class="settlementR">
        <span>总计：</span><span style="font-size: 16px; margin-right: 30px">￥{{ totalMoney.total }}</span>
        <span style="color: #18a44c">已支付：</span><span style="font-size: 16px; color: #18a44c; margin-right: 50px">￥{{
          totalMoney.paid }}</span>
        <span style="color: red">待支付：</span><span style="font-size: 16px; color: red; margin-right: 50px">
          <!-- ￥{{totalMoney.paid==0?0:totalMoney.unpaid}} -->
          ￥{{ totalMoney.unpaid }}
        </span>
        <!-- detail.serviceStatus!=2  已失效 -->
        <el-button v-if="detail.serviceStatus != 2" type="warning" size="small" plain @click="save">保存</el-button>
        <el-button v-if="detail.serviceStatus != 2" type="warning" size="small" @click="createOrder">生成订单</el-button>
      </div>
    </div>
    <!-- 选择支付方式 医疗-->
    <div v-if="yiliao_state">
      <dialogYiLiao :orderNum="orderNumber" @submit="submityiLiao"></dialogYiLiao>
    </div>
  </div>
</template>
<script>
import dialogYiLiao from "../../../../components/dialog_yiliao.vue";
import dialogAddShop from "../../../../components/dialog_addShop.vue";
import dialogChangeGoods from "../../../../components/dialogChangeGoods.vue";
import dialogShouyin from "../../../../components/dialogShouyin.vue";
import dialogQRCode from "../../../../components/dialogQRCode.vue";
import dialogComplete from "../../../../components/dialog_complete.vue";
import dialogChangePlan from "../drawer/drawer_changePlan.vue";
import dialogChangeCarry from "../drawer/drawer_ChangeCarry.vue";

import dialogBatchAdd from "../drawer/dialog_batchAdd.vue";
import dialogBatchEdit from "../drawer/dialog_batchEdit.vue";
import dialogBatchDel from "../drawer/dialog_batchDel.vue";
import moment from "moment";
export default{
  components:{
    dialogAddShop,
    dialogYiLiao,
    dialogChangeGoods,
    dialogShouyin,
    dialogQRCode,
    dialogComplete,
    dialogChangePlan,
    dialogChangeCarry,
    dialogBatchAdd,
    dialogBatchEdit,
    dialogBatchDel,
  },
  data(){
    return {
      yiliao_state: false,
      dialogShouyin_state: false,
      shouyinData: [],

      dialogAddGoods_state: false,
      dialogPay_state: false,
      orderNumber: "",
      codeUrl: "",
      dialogChangeGoods_state: false,
      scopeId: "",
      propsId: "",
      propsRow: "",
      scopeIndex: 0,
      cur_complete_id: "",
      dialogComplete_state: false,

      detail: {},

      selectedArr: [],
      selectedArrArr: [],
      plansMoney: [],
      totalMoney: {},

      // changePlan
      curRow: {},
      dialogChangePlan_state: false,
      dialogChangeCarry_state:false,
      // batch
      dialog_batchAdd_state: false,
      dialog_batchEdit_state: false,
      dialog_batchDel_state: false,
    };
  },
  computed:{
    curShopId() {
      return this.$store.state.shopId;
    },
    userInfo() {
      return this.$store.state.yiliaoxin.userInfo;
    },
    curPetInfo() {
      let obj = this.$store.getters["yiliaoxin/curPetInfo"];
      return obj;
    },
    ymqcParams() {
      return this.$store.state.yiliaoxin.ymqcParams;
    },
  },
  mounted(){
    this.getDetail();
  },
  methods:{
    // 返回
    back() {
      this.$store.commit("yiliaoxin/remove_router");
      if (this.$store.state.yiliaoxin.router.length === 0) {
        this.ymqcParams.type = "list";
        this.$store.commit("yiliaoxin/set_ymqcParams", this.ymqcParams);
        this.$store.commit("yiliaoxin/set_curBusiness", "疫苗驱虫");
      }
      // if(
      // 	this.$store.state.yiliaoxin.curBusinessPre==='工作台'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rBingli'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rYmqc'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rZhuyuan'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenDai'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenZhong'
      // ){
      // 	this.$store.commit('yiliaoxin/set_curBusiness',this.$store.state.yiliaoxin.curBusinessPre)
      // 	return
      // }
      // this.ymqcParams.type = 'list'
      // this.$store.commit("yiliaoxin/set_ymqcParams",this.ymqcParams)
    },
    submit_dialog_batchAdd() {
      this.getDetail();
      this.dialog_batchAdd_state = false;
    },
    submit_dialog_batchEdit() {
      this.getDetail();
      this.dialog_batchEdit_state = false;
    },
    submit_dialog_batchDel() {
      this.getDetail();
      this.dialog_batchDel_state = false;
    },
    changeTotal(e, str, row, type) {
      if (str == "selectPlan") {
        for (let i = 0; i < this.selectedArr.length; i++) {
          for (let a = 0; a < this.selectedArrArr[i].length; a++) {
            if (
              this.detail.plans[i].planGoods[a].canDelete &&
              !this.detail.plans[i].planGoods[a].orderNum
            ) {
              this.$set(this.selectedArrArr[i], a, this.selectedArr[i]);
            }
          }
        }
        this.getTotal();
      } else if (str == "selectGoods") {
        for (let i = 0; i < this.selectedArr.length; i++) {
          let state = false;
          for (let a = 0; a < this.selectedArrArr[i].length; a++) {
            if (this.selectedArrArr[i][a]) state = true;
          }
          this.$set(this.selectedArr, i, state);
        }
        this.getTotal();
      } else if (str == "changeNum") {
        if (type == "blur" && row.num === "") row.num = 1;
        row.num = this.$public.replaceGoodsDosage(row.num);
        let stock = this.$public.getMatchingItem(
          row.skuStocks[row.skuValueIndex].lstStock,
          "shopId",
          this.curShopId
        ).stock;
        let totalTimes = this.$public.getMatchingItem(
          row.skuStocks[row.skuValueIndex].lstStock,
          "shopId",
          this.curShopId
        ).totalTimes;
        if (row.num > stock) {
          this.$message({
            message: "该药品最大数量为" + stock,
            type: "error",
          });
          row.num = stock;
        }
        let goodsDosage = this.$public.cheng(row.num, row.in_exchanage);
        if (goodsDosage > totalTimes) {
          row.goodsDosage = totalTimes;
        } else {
          row.goodsDosage = goodsDosage;
        }
        if (row.num !== "") {
          let params = {
            itemsId: row.itemsId,
            num: Number(row.num),
            allowWholesale: row.allow_wholesale,
            goodsDosage: Number(row.goodsDosage),
          };
          this.$http
            .post("/api/MedicalPackage/Plan/UpdateNum", params)
            .then((res) => {
              if (res.code == 0) {
                console.log("修改数量成功");
              }
              this.getDetail();
            });
        }
      } else if (str == "chajia") {
        this.getTotal();
      } else if (str == "changeGoodsDosage") {
        row.goodsDosage = this.$public.replaceGoodsDosage(row.goodsDosage);
        let totalTimes = this.$public.getMatchingItem(
          row.skuStocks[row.skuValueIndex].lstStock,
          "shopId",
          this.curShopId
        ).totalTimes;
        if (row.goodsDosage > totalTimes) {
          this.$message({
            message: "该药品最大用量为" + totalTimes,
            type: "error",
          });
          row.goodsDosage = totalTimes;
        }
        let num = Math.ceil(
          this.$public.chu(Number(row.goodsDosage), row.in_exchanage)
        );
        row.num = num;
        if (type == "blur" && row.goodsDosage === "") row.goodsDosage = 1;
        if (row.goodsDosage !== "") {
          let params = {
            itemsId: row.itemsId,
            num: Number(row.num),
            allowWholesale: row.allow_wholesale,
            goodsDosage: Number(row.goodsDosage),
          };
          this.$http
            .post("/api/MedicalPackage/Plan/UpdateNum", params)
            .then((res) => {
              if (res.code == 0) {
                console.log("修改用量成功");
              }
              this.getDetail();
            });
        }
      }
    },
    // 计算总价
    getTotal() {
      for (let a = 0; a < this.selectedArr.length; a++) {
        let total = { delPaid: 0, paid: 0, unpaid: 0, total: 0, count: 0 };
        if (this.selectedArr[a]) {
          // 选中的计划
          for (let b = 0; b < this.selectedArrArr[a].length; b++) {
            let goods = this.detail.plans[a].planGoods[b];
            let N =
              goods.allowWholesale === 0 ? goods.countPriceDosage : goods.num;
            if (this.selectedArrArr[a][b]) {
              // 选中的商品
              if (goods === undefined) {
                this.selectedArr.splice(a, 1);
              } else {
                total.count = total.count + 1;
                total.total = this.$public.jia(
                  total.total,
                  this.$public.cheng(N, goods.price)
                );
              }
            }
          }
          let replaceObj = {};
          for (let c = 0; c < this.detail.plans[a].planGoodsAll.length; c++) {
            let goods = this.detail.plans[a].planGoodsAll[c];
            let N =
              goods.allowWholesale === 0 ? goods.countPriceDosage : goods.num;
            if (goods.replaceType === 0 && goods.isPay !== true) {
              // replaceType===0 并且 未支付的金额
              total.unpaid = this.$public.jia(
                total.unpaid,
                this.$public.cheng(N, goods.price)
              );
            }
            if (goods.isPay === true) {
              // 已支付
              if (goods.replaceType === 0) {
                //  没有进行替换的
                total.paid = this.$public.jia(
                  total.paid,
                  this.$public.cheng(N, goods.price)
                );
              } else if (goods.replaceType === 1) {
                if (goods.notCount == false) {
                  total.paid = this.$public.jia(
                    total.paid,
                    this.$public.cheng(N, goods.price)
                  );
                } else {
                  var findItems = this.detail.plans[a].planGoodsAll.find(
                    (m) => {
                      return m.replaceMark === goods.id && m.isPay === true;
                    }
                  );
                  if (findItems === undefined) {
                    total.paid = this.$public.jia(
                      total.paid,
                      this.$public.cheng(N, goods.price)
                    );
                  }
                }
              } else if (goods.replaceType === 2) {
                if (goods.notCount === false) {
                  total.paid = this.$public.jia(
                    total.paid,
                    this.$public.cheng(N, goods.price)
                  );
                }
              }
            }
            if (
              !this.$public.isNull(goods.replaceMark) &&
              goods.isPay !== true
            ) {
              if (replaceObj[goods.replaceMark] == undefined) {
                replaceObj[goods.replaceMark] = [0, 0];
                replaceObj[goods.replaceMark][1] = this.$public.cheng(
                  goods.price,
                  N
                );
              } else {
                replaceObj[goods.replaceMark][1] = this.$public.jia(
                  replaceObj[goods.replaceMark][1],
                  this.$public.cheng(goods.price, N) < 0
                    ? 0
                    : this.$public.cheng(goods.price, N)
                );
              }
            }
          }
          for (let k in replaceObj) {
            let goods = this.detail.plans[a].planGoodsAll.find((item) => {
              return item.id === k;
            }); // 被替换的商品
            let N =
              goods.allowWholesale === 0 ? goods.countPriceDosage : goods.num;
            replaceObj[k][0] = this.$public.cheng(goods.price, N);
            replaceObj[k][2] = goods.notCount;
            if (replaceObj[k][2] === true) {
              // 补差价
              total.unpaid = this.$public.jia(
                total.unpaid,
                this.$public.jian(replaceObj[k][1], replaceObj[k][0])
              );
              total.delPaid = this.$public.jia(total.delPaid, replaceObj[k][0]);
            }
          }
          this.plansMoney[a] = total;
        }
      }
      this.totalMoney = { delPaid: 0, paid: 0, unpaid: 0, total: 0, count: 0 };
      for (let i = 0; i < this.plansMoney.length; i++) {
        if (this.selectedArr[i]) {
          this.totalMoney.unpaid = this.$public.jia(
            this.totalMoney.unpaid,
            this.plansMoney[i].unpaid
          );
          this.totalMoney.delPaid = this.$public.jia(
            this.totalMoney.delPaid,
            this.plansMoney[i].delPaid
          );
          this.totalMoney.count = this.$public.jia(
            this.totalMoney.count,
            this.plansMoney[i].count
          );
          this.totalMoney.paid = this.$public.jia(
            this.totalMoney.paid,
            this.plansMoney[i].paid
          );
          this.totalMoney.total = this.$public.jia(
            this.totalMoney.total,
            this.plansMoney[i].total
          );
        }
      }
    },
    // 无用的保存
    save() {
      this.$message({
        message: " 保存成功",
        type: "success",
      });
    },
    // 生成订单
    createOrder() {
      this.shouyinData = [];
      for (let i = 0; i < this.selectedArrArr.length; i++) {
        if (this.selectedArr[i]) {
          // 如果选中
          for (let a = 0; a < this.selectedArrArr[i].length; a++) {
            if (
              this.selectedArrArr[i][a] &&
              (this.detail.payType == 2
                ? this.detail.plans[i].planGoods[a].currPlan
                : true)
            ) {
              let goods = this.detail.plans[i].planGoods[a];
              if (!goods.isPay && goods.orderNum) {
                this.$message({
                  message: "当前页面有未支付的商品，不可再次生成订单",
                  type: "error",
                });
                return;
              }
              if (!goods.orderNum) {
                this.shouyinData.push(goods);
              }
            }
          }
        }
      }
      if (this.shouyinData.length == 0) {
        if (this.detail.payType === 2) {
          this.$message({
            message: "当前计划内没有要结算的项目",
            type: "error",
          });
        } else {
          this.$message({
            message: "请选择需要结算的项目",
            type: "error",
          });
        }
        return;
      } else {
        for (let i = 0; i < this.shouyinData.length; i++) {
          let goods = this.shouyinData[i];
          if (!goods.orderNum) {
            if (goods.skuValueIndex !== undefined && goods.goodsType === 1) {
              let stock = this.$public.getMatchingItem(
                goods.skuStocks[goods.skuValueIndex].lstStock,
                "shopId",
                this.curShopId
              ).stock;
              if (stock == 0) {
                this.$confirm(
                  goods.goodsName + " 已没有库存,确定要生成订单",
                  "警告",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  }
                ).then(() => {
                  this.dialogShouyin_state = true;
                });
                return;
              } else if (stock < goods.num) {
                this.$confirm(
                  goods.goodsName + " 库存不足,确定要生成订单",
                  "警告",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  }
                ).then(() => {
                  this.dialogShouyin_state = true;
                });
                return;
              }
            }
          }
        }
        this.dialogShouyin_state = true;
      }
    },
    // 收银
    submit_shouyin() {
      this.dialogShouyin_state = false;
      this.getDetail("mounted");
    },
    // 是否补差价
    changeNotCount(b, row) {
      console.log(b, row);
      this.$http
        .get("/api/MedicalPackage/ChangeNotCount", {
          replaceMark: row.replaceMark,
          notCount: !b,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail();
          }
        });
    },
    // 标记为已失效
    changeInvalid() {
      this.$confirm("已失效状态不可撤回，确定标记为已失效吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .get("/api/MedicalPackage/Disabled", { serviceId: this.detail.id })
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getDetail();
            }
          });
      });
    },
    // 修改 疫苗驱虫计划 信息
    changePlan(row) {
      this.curRow = row;
      this.dialogChangePlan_state = true;
    },
    submit_dialogChangePlan(obj) {
      this.dialogChangePlan_state = false;
      if (obj.type === "success") {
        this.getDetail();
      }
    },
     //编辑实施ri'qi
     changeCarry(row) {
      this.curRow = row;
      this.dialogChangeCarry_state = true;
    },
    submit_dialogChangeCarry(obj) {
      this.dialogChangeCarry_state = false;
      if (obj.type === "success") {
        this.getDetail();
      }
    },
    // 添加商品
    addGoods(index) {
      this.scopeId = index;
      this.propsId = "";
      this.propsRow = "";
      this.dialogAddGoods_state = true;
    },
    submit_dialogAddGoods({ goodsItem, skuItem, wayItem, goodsType }) {
      console.log("goodsItem???", goodsItem);

      let row = this.$public.getRow(goodsItem, skuItem, wayItem, goodsType);
      let table = this.detail.plans[this.scopeId].planGoods;
      for (let i = 0; i < table.length; i++) {
        if (!table[i].orderNum) {
          if (
            this.$public.isNull(table[i].orderNum) &&
            table[i].skus == row.skus &&
            table[i].goodsId == row.goodsId
          ) {
            this.$message({
              message: "该商品已添加",
              type: "error",
            });
            return;
          }
        }
      }
      if (row.stock == 0) {
        this.$message({
          message: "该商品已没有库存，请及时申请采购",
          type: "error",
        });
        return;
      }
      let params = {
        serviceId: this.detail.plans[this.scopeId].serviceId,
        planId: this.detail.plans[this.scopeId].planId,
        planName: this.detail.plans[this.scopeId].planName,
        planGoods: [
          {
            brand: row.brand,
            categoryId: row.categoryId,
            categoryName: row.categoryName,
            allowWholesale: row.allow_wholesale,
            outUnit: row.outUnit,
            goodsId: row.goodsId,
            goodsName: row.goodsName,
            otherName: row.otherName,
            isHumanMedication: row.isHumanMedication,
            goodsType: row.goodsType,
            skus: row.skus.split("_") == -1 ? "" : row.skus,
            skuValue: row.skus.split("_") == -1 ? "" : row.skuValue,
            model: row.model,
            unit: row.unit,
            originalPrice: row.originalPrice,
            price: row.price,
            num: row.num,
            activityId: "",
            activityName: "",
            totalMoney: this.$public.cheng(row.num, row.price),
            goodsUsage: "",
            goodsDosage: 1,
            dosageCeiling: Number(row.dosageCeiling), // 向上取整
            dosageCeilingValue: Number(row.dosageCeilingValue), // 向上取整
            goodsTimes: "",
            remark: row.remark,
            extendContent: row.extendContent,
            isNeedCode: row.isNeedCode, // 是否有耗材
          },
        ],
      };
      let loading = this.$loading();
      this.$http
        .post("/api/MedicalPackage/Plan/AddGoods", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.getDetail();
          }
        });
    },
    // 获取详情
    getDetail() {
      let params = {
        id: this.ymqcParams.curRow.id,
      };
      let loading = this.$loading();
      this.$http.get("/api/MedicalPackage/Detail", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          if (res.data.plans == null) {
            res.data.plans = [];
            this.selectedArr = [];
            this.selectedArrArr = [];
          } else {
            for (let i = 0; i < res.data.plans.length; i++) {
              if (res.data.plans[i].planGoods == null) {
                res.data.plans[i].planGoods = [];
              }
              for (let b = 0; b < res.data.plans[i].planGoods.length; b++) {
                res.data.plans[i].planGoods.allow_wholesale =
                  res.data.plans[i].planGoods.allowWholesale;
              }
              res.data.plans[i].planGoodsAll = res.data.plans[i].planGoods;
              res.data.plans[i].planGoods = this.filterPlanGoods(
                res.data.plans[i].planGoods
              );
            }
          }
          this.selectedArr = [];
          this.selectedArrArr = [];
          this.plansMoney = []; // 每次计划的total的集合
          for (let a = 0; a < res.data.plans.length; a++) {
            let currPlan = true;
            if (res.data.payType === 2 && !res.data.plans[a].currPlan) {
              currPlan = false;
            }
            this.selectedArr.push(currPlan);
            this.selectedArrArr.push([]);
            this.plansMoney.push({
              delPaid: 0,
              paid: 0,
              unpaid: 0,
              total: 0,
              count: 0,
            });
            for (let b = 0; b < res.data.plans[a].planGoods.length; b++) {
              this.selectedArrArr[a].push(currPlan);
            }
          }
          // if(str=="mounted"){ // 初始化select数组
          // 	this.selectedArr=[];
          // 	this.selectedArrArr=[];
          // 	this.plansMoney=[]; // 每次计划的total的集合
          // 	for(let a=0;a<res.data.plans.length;a++){
          // 		let currPlan = true;
          // 		if(res.data.payType===2&&!res.data.plans[a].currPlan){
          // 			currPlan=false
          // 		}
          // 		this.selectedArr.push(currPlan)
          // 		this.selectedArrArr.push([])
          // 		this.plansMoney.push({delPaid:0,paid:0,unpaid:0,total:0,count:0})
          // 		for(let b=0;b<res.data.plans[a].planGoods.length;b++){
          // 			this.selectedArrArr[a].push(currPlan);
          // 		}
          // 	}
          // }else{
          // 	for(let a=0;a<res.data.plans.length;a++){
          // 		let currPlan = true;
          // 		if(this.selectedArr[a]===undefined){ // 创建了新计划
          // 			if(res.data.payType===2&&!res.data.plans[a].currPlan){
          // 				currPlan=false
          // 			}
          // 			this.selectedArr[a]=currPlan
          // 			this.selectedArrArr.push([])
          // 			this.plansMoney.push({delPaid:0,paid:0,unpaid:0,total:0,count:0})
          // 		}
          // 		for(let b=0;b<res.data.plans[a].planGoods.length;b++){
          // 			if(this.selectedArrArr[a][b]===undefined){  // 创建了新商品
          // 				if(res.data.payType===2&&!res.data.plans[a].planGoods[b].currPlan){
          // 					currPlan=false
          // 				}
          // 				this.selectedArrArr[a].push(currPlan);
          // 			}
          // 		}
          // 	}
          // }
          let arr = [];
          for (let i = 0; i < res.data.plans.length; i++) {
            for (let a = 0; a < res.data.plans[i].planGoods.length; a++) {
              arr.push(res.data.plans[i].planGoods[a]);
            }
          }
          this.$util.getGoodsInfo(arr).then((goodsList) => {
            for (let i = 0; i < goodsList.length; i++) {
              goodsList[i].allow_wholesale = goodsList[i].allowWholesale;
              this.$set(goodsList[i], "skuValueIndex", 0);
              goodsList[i].skuStocks = goodsList[i].skuStocks || [];
              for (let a = 0; a < goodsList[i].skuStocks.length; a++) {
                if (
                  goodsList[i].skuValue == goodsList[i].skuStocks[a].skuValue
                ) {
                  this.$set(goodsList[i], "skuValueIndex", a);
                  // this.$set(goodsList[i],'originalPrice',goodsList[i].skuStocks[a].salePrice)
                  this.$set(
                    goodsList[i],
                    "skus",
                    goodsList[i].skuStocks[a].skus
                  );
                  this.$set(
                    goodsList[i],
                    "skuValue",
                    goodsList[i].skuStocks[a].skuValue
                  );
                }
              }
            }
            this.detail = res.data;
            this.getTotal();
            this.getPayAddr(this.detail.id);
            let ymqcExpandedIds =
              JSON.parse(sessionStorage.getItem("ymqcExpandedIds")) || [];
            let arr = ymqcExpandedIds[this.$route.query.id] || [];
            for (let i = 0; i < this.detail.plans.length; i++) {
              if (arr.indexOf(this.detail.plans[i].planId) > -1) {
                this.$nextTick(() => {
                  this.$refs.table.toggleRowExpansion(
                    this.detail.plans[i],
                    true
                  );
                });
              }
            }
          });
        }
      });
    },
    openDialogPay() {
      this.$http
        .get("/api/Order/GetServiceOrder", { serviceId: this.detail.id })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.length === 0) {
              this.$message({
                message: "该订单已支付或已取消",
                type: "success",
              });
              this.getDetail();
              return;
            } else {
              if (res.data[0].totalMoney === 0) {
                this.$message({
                  message: "待支付金额为0，请联系前台进行支付",
                  type: "error",
                });
              } else {
                this.yiliao_state = true;
                // this.$http.get('/api/Pay/GotoPay', {orderNum:this.orderNumber}).then(res1 => {
                // 	if (res1.code == 0) {
                // 		this.codeUrl = res1.data.codeUrl
                // 		this.dialogPay_state = true
                // 	}
                // })
              }
            }
          }
        });
    },
    // 关闭医疗支付弹框
    submityiLiao() {
      this.yiliao_state = false;
    },
    closeOrder() {
      this.$http
        .get("/api/Order/GetServiceOrder", { serviceId: this.detail.id })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.length === 0) {
              this.$message({
                message: "该订单已支付或已取消",
                type: "success",
              });
              this.getDetail();
              return;
            } else {
              this.$confirm("确定要取消已生成的订单?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.$http
                  .get("/api/Order/ReceivedOrder", {
                    order_id: this.orderNumber,
                  })
                  .then((res) => {
                    if (res.code == 0) {
                      this.$message({
                        message: "取消成功",
                        type: "success",
                      });
                      this.getDetail();
                    }
                  });
              });
            }
          }
        });
    },
    submit_dialog_pay() {
      this.dialogPay_state = false;
      this.getDetail();
    },
    // 获取支付地址
    getPayAddr(serviceId) {
      this.orderNumber = "";
      this.$http
        .get("/api/Order/GetServiceOrder", { serviceId: serviceId })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              this.orderNumber = res.data[0].orderNumber;
            }
          }
        });
    },
    // 更换商品
    changeGoods(row, scopeIndex, propsIndex) {
      this.scopeId = scopeIndex;
      this.propsId = propsIndex;
      this.propsRow = row;
      this.dialogChangeGoods_state = true;
    },
    // 更换商品
    submitChangeGoods(obj) {
      this.dialogChangeGoods_state = false;
      if (obj.type == "close") return;
      if (obj.type == "cancel") return;
      let params = {
        planId: this.detail.plans[this.scopeId].planId,
        planName: this.detail.plans[this.scopeId].planName,
        beforeGoods: obj.beforeGoods,
        afterGoods: obj.afterGoods,
      };
      let loading = this.$loading();
      this.$http
        .post("/api/MedicalPackage/Plan/Replace", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$message({
              message: "更换成功",
              type: "success",
            });
            this.getDetail();
          }
        });
    },
    // 取消更换
    cancelGoods(row) {
      this.$confirm("确定取消更换?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          itemsId: row.itemsId,
        };
        let loading = this.$loading();
        this.$http
          .get("/api/MedicalPackage/Plan/CancelReplace", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.$message({
                message: "取消成功",
                type: "success",
              });
              this.getDetail();
            }
          });
      });
    },
    // 删除计划
    deletePlan(row, index) {
      this.$confirm("确定要删除该计划?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .delete("/api/MedicalPackage/Plan/Delete", { planId: row.planId })
          .then((res) => {
            if (res.code == 0) {
              this.detail.plans.splice(index, 1);
              this.plansMoney.splice(index, 1);
              this.selectedArr.splice(index, 1);
              this.selectedArrArr.splice(index, 1);
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getDetail();
            }
          });
      });
    },
    // 删除计划内的商品
    deleteGoods(row, scopeId, propsId) {
      this.$confirm("确定要删除该商品?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .delete("/api/MedicalPackage/Plan/DeleteGoods", {
            planId: row.planId,
            goodsItemsId: row.itemsId,
            planExtendContent: JSON.stringify({
              planPaid: this.plansMoney[scopeId].paid,
            }),
          })
          .then((res) => {
            if (res.code == 0) {
              this.selectedArrArr[scopeId].splice(propsId, 1);
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getDetail();
            }
          });
      });
    },
    // 验证计划是否在有效期内
    checkedCompleteBtn(planDate) {
      let d1 = this.$public.FTime(new Date().getTime(), "YYYY-MM-DD");
      let d2 = this.$public.FTime(planDate, "YYYY-MM-DD");
      if (
        moment(d1).isAfter(d2, "day") === false &&
        moment(d1).isSame(d2, "day") === false
      ) {
        return false;
      } else {
        return true;
      }
    },
    // 已完成
    completePlan(row) {
      this.cur_complete_id = row.planId;
      this.dialogComplete_state = true;
    },
    submit_dialog_complete(str) {
      if (str === "success") {
        this.getDetail();
      }
      this.cur_complete_id = "";
      this.dialogComplete_state = false;
    },
    expandChange(row, expandedRows) {
      let o = {};
      o[this.$route.query.id] = [];
      for (let i = 0; i < expandedRows.length; i++) {
        o[this.$route.query.id].push(expandedRows[i].planId);
      }
      sessionStorage.setItem("ymqcExpandedIds", JSON.stringify(o));
    },
    // 过滤
    filterPlanGoods(arr) {
      let arr1 = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].replaceType !== 1) {
          // 有更换的商品
          arr1.push(arr[i]);
        }
      }
      return arr1;
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  position: relative;
  height: 100%;
  padding-bottom: 68px;
  box-sizing: border-box;

  .compContent {
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    overflow: auto;

    .title {
      display: flex;
      height: 47px;
      line-height: 27px;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px 18px;
      box-sizing: border-box;

      .titleL {
        width: 50%;
        font-size: 14px;
        font-weight: bold;
      }

      .titleR {
        width: 50%;
        text-align: right;

        .titleRText {
          display: inline-block;
          font-size: 14px;
          color: $mainColor;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }

    .content {
      position: relative;
      padding: 23px 0 20px;
      width: 100%;
      height: calc(100% - 47px);
      box-sizing: border-box;
      overflow: auto;

      .no {
        font-size: 14px;
        color: $fontColor;
        font-weight: bold;
        padding: 0 24px 24px;
      }

      .msg {
        display: flex;
        flex-wrap: wrap;
        padding: 0 24px 8px;
        border-bottom: 1px solid #f2f2f2;

        .item {
          width: 20%;
          font-size: 12px;
          color: $fontColor;
          display: flex;
          padding-bottom: 16px;

          .label {
            width: 60px;
            text-align: right;
          }

          .value {
            text-align: left;
          }
        }
      }

      .relation {
        padding: 10px 0 8px;

        .relationTitLine {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          color: $fontColor;
          padding: 0 24px;
        }

        .goodsLine {
          background-color: #f3f6ff;
          border: 1px solid #e4e7f8;
          border-radius: 4px;

          .goodsLineTit {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            color: $fontColor;
            padding: 6px 16px;
            line-height: 32px;
          }

          ::v-deep .el-table tr {
            background-color: #f3f6ff;

            th {
              background-color: #f3f6ff;
              border-top: 1px solid #e0e2f1;
              border-bottom: 1px solid #e0e2f1;
            }

            td {
              border-bottom: 1px solid #e0e2f1;
            }
          }
        }
      }
    }
  }

  .settlement {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 56px;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    padding: 12px 20px;
    box-sizing: border-box;

    .settlementL {
      width: 40%;
      font-size: 14px;
      line-height: 32px;
    }

    .settlementR {
      width: 60%;
      text-align: right;

      .text {
        color: $fontColor;
        font-size: 14px;
        padding: 0px 24px 0;
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>
